var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-form-group',{attrs:{"label":_vm.$fieldTitle('path'),"page":"page","placeholder":_vm.$placeholder('path'),"error-message":_vm.$errorMessage(_vm.errors, 'path')},model:{value:(_vm.delivery.path),callback:function ($$v) {_vm.$set(_vm.delivery, "path", $$v)},expression:"delivery.path"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }